import { render, staticRenderFns } from "./RouterInfo.vue?vue&type=template&id=1ef2d0f9&scoped=true&"
import script from "./RouterInfo.vue?vue&type=script&lang=js&"
export * from "./RouterInfo.vue?vue&type=script&lang=js&"
import style0 from "./RouterInfo.vue?vue&type=style&index=0&id=1ef2d0f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef2d0f9",
  null
  
)

export default component.exports